// Jubris - Optimised Variant Scroll
(function () {
  'use strict';

  // Throttle to prevent multiple rapid triggers
  let isScrolling = false;

  function scrollToProductTop() {
    if (isScrolling) return;
    isScrolling = true;

    const productTop = document.querySelector(
      '.product__media-wrapper, .product-single__photos, .product__media, .product-media-container, .product__photo-container'
    );

    if (productTop) {
      productTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    setTimeout(function () { isScrolling = false; }, 400);
  }

  // Fast, delegated event listener
  document.addEventListener('change', function (e) {
    const isVariantOption =
      e.target.closest('.variant-input-wrap') ||
      e.target.closest('.swatch') ||
      e.target.closest('fieldset') ||
      (e.target.tagName === 'SELECT' && e.target.name === 'id') ||
      e.target.type === 'radio';

    if (isVariantOption) {
      setTimeout(scrollToProductTop, 80); // faster than before (was 150ms)
    }
  }, { passive: true }); // passive = better scroll performance

})();
